import { getStoryFromGlobalStoryblokStoriesBySlug } from "../../../utils/global-story-functions";
import { useGlobalStoryblokStories } from "../../../utils/with-global-story";
import { findPdpBannerForProduct, PdpBanner } from "./pdp-banner";

export const PdpBannerForProduct = ({
  productSku,
}: {
  productSku: string | undefined;
}) => {
  const globalStoryblokStories = useGlobalStoryblokStories();
  const pdpBannerPage = getStoryFromGlobalStoryblokStoriesBySlug(
    "shared-content/pdp-banners",
    globalStoryblokStories,
  );
  const pdpBannerBlok = findPdpBannerForProduct(
    pdpBannerPage?.pageContent,
    productSku,
  );

  if (!pdpBannerBlok) return null;

  return <PdpBanner {...pdpBannerBlok} />;
};
